import { useContext } from "react";
import { DelayPickingOrderContext } from "../Contexts/order-context/DelayPickingOrderContext";

export const useDelayPicking = () => useContext(DelayPickingOrderContext);
